module.exports = __webpack_public_path__ + "img/screenshot_new16.709dcefc.png";